window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.pokerTurnirPobjedniciRepo = function () {

    var url = 'api/pokerturnirpobjednici';

    var list = function (dbNaziv) {

        var params = {
            dbNaziv: (dbNaziv || '')
        };

        return fetch(url + casino.repos.base.serializeGetParams(params))
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

    };

    return {
        list: list
    }

}();